import useBaseFetch from "../../internal/fetch/useBaseFetch";
/**
 *
 * @see https://sail.stripe.me/data/api/useJsonFetch
 */ export default function useJsonFetch(/** The URL of the resource to be fetched. */ url, /** An object containing custom settings to be applied to the request. */ options = {}) {
    return useBaseFetch(url, options, 'json');
}

//# sourceMappingURL=useJsonFetch.js.map